import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";

// Pages
import User from "@/pages/Dashboard/Pages/UserProfile.vue";
import Pricing from "@/pages/Dashboard/Pages/Pricing.vue";
import TimeLine from "@/pages/Dashboard/Pages/TimeLinePage.vue";
import RtlSupport from "@/pages/Dashboard/Pages/RtlSupport.vue";
// import Login from "@/pages/Dashboard/Pages/Login.vue";
import Register from "@/pages/Dashboard/Pages/Register.vue";
import Lock from "@/pages/Dashboard/Pages/Lock.vue";

// Components pages
import Buttons from "@/pages/Dashboard/Components/Buttons.vue";
import GridSystem from "@/pages/Dashboard/Components/GridSystem.vue";
import Panels from "@/pages/Dashboard/Components/Panels.vue";
import SweetAlert from "@/pages/Dashboard/Components/SweetAlert.vue";
import Notifications from "@/pages/Dashboard/Components/Notifications.vue";
import Icons from "@/pages/Dashboard/Components/Icons.vue";
import Typography from "@/pages/Dashboard/Components/Typography.vue";

// Forms pages
import RegularForms from "@/pages/Dashboard/Forms/RegularForms.vue";
import ExtendedForms from "@/pages/Dashboard/Forms/ExtendedForms.vue";
import ValidationForms from "@/pages/Dashboard/Forms/ValidationForms.vue";
import Wizard from "@/pages/Dashboard/Forms/Wizard.vue";

// TableList pages
import RegularTables from "@/pages/Dashboard/Tables/RegularTables.vue";
import ExtendedTables from "@/pages/Dashboard/Tables/ExtendedTables.vue";
import PaginatedTables from "@/pages/Dashboard/Tables/PaginatedTables.vue";

// Maps pages
import GoogleMaps from "@/pages/Dashboard/Maps/GoogleMaps.vue";
import FullScreenMap from "@/pages/Dashboard/Maps/FullScreenMap.vue";
import VectorMaps from "@/pages/Dashboard/Maps/VectorMaps.vue";

// Calendar
import Calendar from "@/pages/Dashboard/Calendar.vue";
// Charts
import Charts from "@/pages/Dashboard/Charts.vue";
import Widgets from "@/pages/Dashboard/Widgets.vue";

// Fanfest
import Login from "@/pages/Login/Login.vue";
import ListGames from "@/pages/Games/List.vue";
import GameDetail from "@/pages/Games/Detail.vue";
import CreateEditUser from "@/pages/User/CreateEdit.vue";
import GameCreate from "@/pages/Games/Create.vue";
import GameEdit from "@/pages/Games/Edit.vue";
import GameDownloadImages from "@/pages/Games/DownloadImages.vue";
import ListUsers from "@/pages/User/List.vue";
import ListSurvey from "@/pages/Survey/List.vue";
import CreateEditSurvey from "@/pages/Survey/CreateEdit.vue";
//  Teams
import ListTeams from "@/pages/Teams/List.vue";
import TeamCreate from "@/pages/Teams/Create.vue";
import TeamDetail from "@/pages/Teams/Detail.vue";
//   Stadiums
import ListStadiums from "@/pages/Stadiums/List.vue";
import StadiumCreateEdit from "@/pages/Stadiums/CreateEdit.vue";
// Editorial
import ListEditorial from "@/pages/Editorial/List.vue";
import FormEditorial from "@/pages/Editorial/Form.vue";
// Ticketera
import ListTicketera from "@/pages/Ticketera/List.vue";
import FormTicketera from "@/pages/Ticketera/Create.vue";
import DetailTicketera from '@/pages/Ticketera/Detail/Tickets.vue';
import DetailSubscriptions from '@/pages/Ticketera/Detail/Subscriptions.vue';
import StatisticsTicketera from '@/pages/Ticketera/Statistics.vue';
// Season
import ListSeason from "@/pages/Season/List.vue";
import FormSeason from "@/pages/Season/CreateEdit.vue";
// Tutorial
import EditTutorial from "@/pages/Tutorial/Edit.vue";
// Banner
import EditBanner from "@/pages/Banner/Edit.vue";
// Advertising
import Advertising from '@/pages/Advertising/Main.vue';
import AdvertisingCreateEdit from '@/pages/Advertising/CreateEdit.vue';

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: { default: Buttons }
    },
    {
      path: "grid-system",
      name: "Grid System",
      components: { default: GridSystem }
    },
    {
      path: "panels",
      name: "Panels",
      components: { default: Panels }
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      components: { default: SweetAlert }
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications }
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons }
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography }
    }
  ]
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      components: { default: RegularForms }
    },
    {
      path: "extended",
      name: "Extended Forms",
      components: { default: ExtendedForms }
    },
    {
      path: "validation",
      name: "Validation Forms",
      components: { default: ValidationForms }
    },
    {
      path: "wizard",
      name: "Wizard",
      components: { default: Wizard }
    }
  ]
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  name: "Tables",
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      components: { default: RegularTables }
    },
    {
      path: "extended",
      name: "Extended Tables",
      components: { default: ExtendedTables }
    },
    {
      path: "paginated",
      name: "Pagianted Tables",
      components: { default: PaginatedTables }
    }
  ]
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      components: { default: GoogleMaps }
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      meta: {
        hideContent: true,
        hideFooter: true,
        navbarAbsolute: true
      },
      components: { default: FullScreenMap }
    },
    {
      path: "vector-map",
      name: "Vector Map",
      components: { default: VectorMaps }
    }
  ]
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Page",
      components: { default: User }
    },
    {
      path: "timeline",
      name: "Timeline Page",
      components: { default: TimeLine }
    },
    {
      path: "rtl",
      name: "وحة القيادة",
      meta: {
        rtlActive: true
      },
      components: { default: RtlSupport }
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing
    },
    {
      path: "/lock",
      name: "Lock",
      component: Lock
    }
  ]
};

// const routes = [
//   {
//     path: "/",
//     redirect: "/dashboard",
//     name: "Home"
//   },
//   componentsMenu,
//   formsMenu,
//   tablesMenu,
//   mapsMenu,
//   pagesMenu,
//   authPages,
//   {
//     path: "/",
//     component: DashboardLayout,
//     children: [
//       {
//         path: "dashboard",
//         name: "Dashboard",
//         components: { default: Dashboard }
//       },
//       {
//         path: "calendar",
//         name: "Calendar",
//         components: { default: Calendar }
//       },
//       {
//         path: "charts",
//         name: "Charts",
//         components: { default: Charts }
//       },
//       {
//         path: "widgets",
//         name: "Widgets",
//         components: { default: Widgets }
//       }
//     ]
//   }
// ];

const routes = [
  {
    path: "/login",
    component: Login
  },
  {
    path: "/",
    component: DashboardLayout,
    children: [
      // games
      {
        path: "/list/games",
        component: ListGames
      },
      {
        path: '/game/create',
        component: GameCreate
      },
      {
        path: '/game/edit/:id',
        component: GameEdit
      },
      {
        path: '/game/manage/:id',
        component: GameDetail
      },
      {
        path: '/game/pictures/:gameId/:teamId',
        component: GameDownloadImages
      },
      // users
      {
        path: '/list/users',
        component: ListUsers
      },
      {
        path: '/user/create',
        component: CreateEditUser
      },
      {
        path: '/user/edit/:id',
        component: CreateEditUser
      },
      // surveys
      {
        path: '/list/survey',
        component: ListSurvey
      },
      {
        path: '/survey/create',
        component: CreateEditSurvey
      },
      {
        path: '/survey/:id',
        component: CreateEditSurvey
      },
      // teams
      {
        path: "/list/teams",
        component: ListTeams
      },
      {
        path: "/teams/create",
        component: TeamCreate
      },
      {
        path: "/team/:id",
        component: TeamDetail
      },
      // stadiums
      {
        path: "/list/stadiums",
        component: ListStadiums
      },
      {
        path: "/stadiums/create",
        component: StadiumCreateEdit
      },
      {
        path: "/stadiums/:id",
        component: StadiumCreateEdit
      },
      // editorial
      {
        path: "/list/editorial",
        component: ListEditorial
      },
      {
        path: "/editorial/create",
        component: FormEditorial
      },
      {
        path: "/editorial/:id",
        component: FormEditorial
      },
      // ticketera
      {
        path: "/list/ticketera",
        component: ListTicketera
      },
      {
        path: "/ticketera/create",
        component: FormTicketera
      },
      {
        path: "/ticketera/detail/ticket/:id",
        component: DetailTicketera
      },
      {
        path: "/ticketera/detail/subscriptions/:id",
        component: DetailSubscriptions
      },
      {
        path: "/ticketera/statistics",
        component: StatisticsTicketera
      },
      // season
      {
        path: "/list/season",
        component: ListSeason 
      },
      {
        path: "/season/create",
        component: FormSeason 
      },
      {
        path: "/season/:id",
        component: FormSeason 
      },
      // tutorial
      {
        path: "/tutorial",
        component: EditTutorial
      },
      {
        path: "/banner",
        component: EditBanner
      },
      // advertising
      {
        path: "/list/advertising",
        component: Advertising
      },
      {
        path: "/advertising/create",
        component: AdvertisingCreateEdit
      },
      {
        path: "/advertising/:id",
        component: AdvertisingCreateEdit
      }
    ]
  }
];

export default routes;
